import React, { useState } from 'react';
import classnames from 'classnames';
import { Link } from '../Sidebar';
import { history } from '../../../model/history';

import './SidebarLink.css';
import { NavLink } from 'react-router-dom';
import { Collapse } from '@nerdgeschoss/shimmer-component-collapse';

interface Props {
  link: Link;
  actions?: React.ReactNode[];
  onSelectLink?: () => void;
}

export function SidebarLink({ link, actions, onSelectLink }: Props): JSX.Element {
  const [expanded, setExpanded] = useState(true);

  function handleOnClick(): void {
    if (link.links) {
      setExpanded(!expanded);
    } else if (link.path) {
      history.push(link.path);
      if (onSelectLink) {
        onSelectLink();
      }
    }
  }

  function isLink(item: Link): boolean {
    if (item.path && (!item.links || item.links.length === 0)) {
      return true;
    }
    return false;
  }

  return (
    <div
      className={classnames('sidebar-link', {
        'sidebar-link--secondary': link.secondary,
        'sidebar-link--expanded': expanded,
      })}
    >
      {isLink(link) && (
        <NavLink exact activeClassName="sidebar-link--active" to={link.path || ''} className="sidebar-link__header">
          {link.icon && <div className="sidebar-link__icon">{link.icon}</div>}
          <div className="sidebar-link__text">{link.text}</div>
        </NavLink>
      )}
      {!isLink(link) && (
        <>
          <header className="sidebar-link__header" onClick={handleOnClick}>
            {link.icon && <div className="sidebar-link__icon">{link.icon}</div>}
            <div className="sidebar-link__text">{link.text}</div>
            {link.links && <div className="sidebar-link__sub-menu-toggle" />}
            {actions && (
              <div className="sidebar-link__actions">
                {actions.map((action) => {
                  return action;
                })}
              </div>
            )}
          </header>
          <div className="sidebar-link__content">
            {link.links && (
              <Collapse open={expanded}>
                <ul className="sidebar-links sidebar-link__sub-menu">
                  {link.links.map((sublink, index) => {
                    return (
                      <li className="sidebar-link__sub-menu-item" key={index}>
                        <SidebarLink link={sublink} onSelectLink={onSelectLink} />
                      </li>
                    );
                  })}
                </ul>
              </Collapse>
            )}
          </div>
        </>
      )}
    </div>
  );
}
